import React, { FC, useState, useEffect } from "react";
import CreateFlow from "../molecules/CreateFlow";
import MainLayout from '../../Layouts/MainLayout';
import SectionHeader from "../molecules/SectionHeader";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "../../../config/axios";
import Spinner from "../atoms/Spinner";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
import { format, parseISO } from 'date-fns';
import FlowList from "../molecules/FlowList";
import { service } from "../../../services/AxiosServices";
interface FlowDetails {
  id: number;
  name: string;
  updatedOn: string;
  description: string;
  createdBy: string;
  agents: number
}
const Flows: FC = () => {
  const { id } = useParams()

  const location = useLocation()
  const { crewName } = location.state || {}
  const [flowsDetails, setFlowsDetails] = useState<FlowDetails[]>([]);
  const [loading, setLoading] = useState<boolean>(false)
  const crewId = Number(id)
  const accessCheckLoading = useAccessCheckLoading()


  useEffect(() => {
    const listFlows = async () => {
      try {
        setLoading(true)
        const response = await service<{ data: any[] }>(
          "/api/get-all-flows",
          "post",
          { crew_id: id }
        );
        setFlowsDetails(response?.data?.data?.map((flow: any) => ({
          id: flow.id,
          name: flow.flow_name,
          description: flow.flow_description,
          updatedOn: format(parseISO(flow.updated_at), 'dd-MM-yyyy, HH:mm'),
          createdBy: 'Admin',
          agents: flow.agent_order.length
        })))
      }
      catch (err) {

      }
      finally {
        setLoading(false)
      }
    }
    listFlows();
  }, [])

  const navigate = useNavigate()
  const handleFlow = () => {
    navigate(`/create_flows/${id}`, { state: { crewName } })
  }
  const handleDeleteFLow = (id: number) => {
    setFlowsDetails((prevFlows) => prevFlows.filter((flow) => flow.id !== id));
  };
  return (
    <>
      <MainLayout>
      <AccessControl
    requiredPermissions={[
          {
            permission: "manage_flows",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
        <SectionHeader 
        back={true}
        title={'Flows'} 
        onAdd={handleFlow}
        action="Create"
        permissionName={
          'manage_flows'
         }
         permissionTypes={['create']}
        link={`/create_flows/${id}`} />
        {loading ?
          (<Spinner />)
          :
          (
            flowsDetails.length > 0 ?
              <FlowList flows={flowsDetails} onDelete={handleDeleteFLow} crewName={crewName} crewId={crewId} />
              :
              <div className="container">
                <div className="row">
                  <div className="mt-4 text-danger text-center">No flows found.</div>
                </div>
              </div>
          )}
</AccessControl>
      </MainLayout>
    </>
  )
}
export default Flows